import { z } from 'zod';
import { itemLegacySchema } from './item/item-legacy-dto';

/**
 * Loop items response DTO
 * Response from GET /api/v1/loop-visualization/:loopId/items endpoint.
 * Tree hierarchy is calculated client-side from item.parentId.
 */
export const loopItemsResponseSchema = z.object({
  items: z.array(itemLegacySchema),
});

export type LoopItemsResponseDTO = z.infer<typeof loopItemsResponseSchema>;
